import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DeductionList from "../components/Deduction/DeductionList";

export default function DeductionPage() {
  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box mb={2}>
        <Typography variant="h6">รายงานการหักเงินพนักงาน</Typography>
        <Typography variant="body2" color="text.secondary">
          สรุปยอดหักรวมรายเดือน แยกตามสายส่ง
        </Typography>
      </Box>
      <DeductionList />
    </Box>
  );
}
